import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { clsx } from 'clsx'

const TABBAR_ITEMS = [
  { id: 'home', path: '/', icon: 'home', activeIcon: 'home' },
  { id: 'vehicles', path: '/vehicles', icon: 'directions_car', activeIcon: 'directions_car' },
  { id: 'trackOrder', path: '/track-search', icon: 'local_shipping', activeIcon: 'local_shipping' },
] as const

export default function Tabbar() {
  const { t } = useTranslation()
  const location = useLocation()

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/'
    return location.pathname.startsWith(path)
  }

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-header bg-white border-t border-neutral-200 shadow-[0_-2px_10px_rgba(0,0,0,0.06)]"
         style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}>
      <div className="flex h-14">
        {TABBAR_ITEMS.map((item) => {
          const active = isActive(item.path)
          return (
            <Link
              key={item.id}
              to={item.path}
              className="flex flex-col items-center justify-center flex-1"
            >
              <span
                className={clsx(
                  'material-icons-round text-2xl',
                  active ? 'text-primary-600' : 'text-neutral-400'
                )}
              >
                {active ? item.activeIcon : item.icon}
              </span>
              <span
                className={clsx(
                  'text-[11px] mt-0.5',
                  active ? 'text-primary-600 font-medium' : 'text-neutral-500'
                )}
              >
                {t(`nav.${item.id}`)}
              </span>
            </Link>
          )
        })}
      </div>
    </nav>
  )
}
